import axios from "../config/axios-chatbot";


// flowUid or projectId is required by the backend; subProjectId narrows further
export const NotificationsRepository = {
  getAllNotifications: ({flowUid, projectId, subProjectId, page = 0, size = 5, sortBy = "id", sortDir = "desc", signal}) =>
    axios.get("/api/notifications", {
      params: { flowUid, projectId, subProjectId, page, size, sortBy, sortDir },
      signal
    }),
    
  getNotification: ({id}) => axios.get(`/api/notifications/${id}`),
  
  createNotification: ({body}) => axios.post("/api/notifications", {...(body || {})}),
  
  updateNotification: ({id, body}) => axios.put(`/api/notifications/${id}`, {...(body || {})}),
  
  deleteNotification: ({id}) => axios.delete(`/api/notifications/${id}`),
  
  getNotificationsCount: ({flowUid, projectId, subProjectId, username, signal}) =>
    axios.get("/api/notifications/count", {params: {flowUid, projectId, subProjectId, username}, signal}),
  
  notificationExists: ({id}) => axios.get(`/api/notifications/exists/${id}`),
  
  // empty notificationIds: every unread notification of the user matching flowUid / projectId / subProjectId
  markNotificationsAsViewed: ({notificationIds, username, flowUid, projectId, subProjectId}) =>
    axios.put("/api/notifications/mark-viewed", {
      notificationIds,
      username,
      flowUid,
      projectId,
      subProjectId
    })
}